import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { AnyoneHomePropertyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: AnyoneHomePropertyConfiguration;
    update: (newConfig?: AnyoneHomePropertyConfiguration) => void;
}

const AnyoneHomeConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Anyone Home Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(open ? { emailDestination: '', accountId: undefined } : undefined)
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Email',
                            invalidText: 'Please enter an Anyone Home Email Destination'
                        }}
                        inputProps={{
                            id: 'email-destination',
                            name: 'AnyoneHomePropertyId',
                            value: props.config.emailDestination,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                emailDestination: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Account ID',
                            invalidText: 'Please enter an Anyone Home Account ID'
                        }}
                        inputProps={{
                            id: 'account-id',
                            name: 'AnyoneHomeAccountId',
                            value: props.config.accountId,
                            type: 'string',
                            required: false,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                accountId: value ? value.toString() : undefined
                            })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default AnyoneHomeConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/AnyoneHomeConfigurationSection.tsx